import { FC } from "react";
import styles from "./download.module.scss";

interface IProps {
  file: any;
}

const FileMetadata: FC<IProps> = (props: IProps) => {
  const { file } = props;

  const bytesToGb = (kb: number): string => {
    return kb ? `${(kb / 1024 / 1024 / 1024).toFixed(2)} GB ` : "0 GB";
  };

  return (
    <div className={styles.fileMeta}>
      <div className={styles.fileSize}>
        <span className={styles.gbSize}>{bytesToGb(file.length)}</span>
      </div>
    </div>
  );
};

export default FileMetadata;
